import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent.vue?vue&type=template&id=b22bbb90"
import script from "./RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports